let bureauTable = [
  {
    label: "单位编号",
    prop: "departmentId",
    sortable: 1
  },
  {
    label: "单位名称",
    prop: "departmentName",
  },
  {
    label: "所属地区",
    prop: "regionId",
  },
  {
    label: "机构级别",
    prop: "level"
  },
  {
    label: "领导",
    prop: "leaderId",
  },
  {
    label: "管理员账号",
    prop: "username",
  },
  {
    label: "备注",
    prop: "remarks",
  },
]


export {
  bureauTable
}